import { useContext, useEffect, useRef } from "react";

import { DataContext } from "@/models/DataProvider";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";

const AVAILABILITY_REFRESH_MS = 5 * 60_000;

export default function UseWorkspaceMembershipAbilities() {
  const { fetchWorkspaceMembershipAvailabilities } = useContext(DataContext);
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const workspaceIdRef = useRef(currentWorkspaceId);
  workspaceIdRef.current = currentWorkspaceId;
  const fetchRef = useRef(fetchWorkspaceMembershipAvailabilities);
  fetchRef.current = fetchWorkspaceMembershipAvailabilities;

  useEffect(() => {
    if (!currentWorkspaceId) return;

    const interval = setInterval(() => {
      fetchRef.current?.(workspaceIdRef.current)?.catch(() => {});
    }, AVAILABILITY_REFRESH_MS);

    return () => clearInterval(interval);
  }, [currentWorkspaceId]);
}
